module.exports = __webpack_public_path__ + "img/QR_en_tc.2141ac9a.jpg";